export const emojiDefault = {
  yes: '✅',
  no: '❌',
  congrats: '🎉',
  hand: '🖐',
  fire: '🔥',
  like: '❤️',
};
